import { dataApiUrl } from '../url';
import AuthAxios from '../auth-axios';

const DataApiUrl = `${dataApiUrl()}/spotify`;

export async function searchSpotify(query, types = ['album', 'artist', 'track', 'year', 'upc', 'isrc', 'genre']) {
  return AuthAxios.get(`${DataApiUrl}/search`, { params: { query, types } }).then(res => res.data.data);
}
